<template>
  <div class="mb-3">
    <info-section-table :fields="fields" :data="data">
      <template v-slot:header>
        <h4 class="blue-text">{{L10n('quote')}}</h4>
      </template>
      <template v-slot:cell-_includeMultiple="{ row }">
        <el-checkbox :value="row._includeMultiple" @change="handleChange($event, row)"/>
      </template>
      <template v-slot:cell-chosen="{ row }">
        <span class="icon-db" :class="{'is-false': !row.chosen, 'is-true': row.chosen}"></span>
      </template>
      <template v-slot:cell-partNumber="{ row }">
        {{dataSourcePartNumber.map[row.partID] && dataSourcePartNumber.map[row.partID].partNumber}}
      </template>
      <template v-slot:cell-price="{ row }">
        {{row.price | toPriceCurrency(dataSourceCurrency.map[row.currencyID] && dataSourceCurrency.map[row.currencyID].title)}}
      </template>
      <template v-slot></template>
      <template v-slot:row-controls="{ row }">
        <slot name="controls" :row="row">
        </slot>
      </template>
    </info-section-table>
    <div class="d-flex align-items-end justify-content-end">
      <logo-button :disabled="disabledMultiple" @click="handleOnSendMultiple" :getPdfContent="getPdfContent">{{L10n('send-quote-multiple')}}</logo-button>
    </div>
  </div>
</template>

<script>
import { createParams } from '@/utils/dynamic'
import { api } from '@/services/api'
import { ServicePdf } from '@/services/pdf-generators'

export default {
  name: 'InfoStep',
  components: {
    'info-section-table': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Table.vue'),
    'logo-button': () => import(/* webpackChunkName: 'UI' */ '@/components/Shared/LogoButton')
  },
  props: {
    rfqID: { type: String },
    data: { type: Array },
    fieldList: { type: Array }
  },
  watch: {
    data: {
      immediate: true,
      handler () {
        this.updateDataSourcePartNumber()
      }
    }
  },
  data () {
    return {
      dataSourcePartNumber: {
        map: {},
        records: []
      },
      defaultFields: [
        { title: this.L10n('include-multiple'), fieldName: '_includeMultiple' },
        { title: this.L10n('chosen'), fieldName: 'chosen' },
        { title: this.L10n('part-number'), fieldName: 'partNumber' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('price'), fieldName: 'price' }
      ]
    }
  },
  computed: {
    fields () {
      return this.fieldList || this.defaultFields
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    disabledMultiple () {
      return !this.data.some(({ _includeMultiple }) => !!_includeMultiple)
    }
  },
  methods: {
    handleOnSendMultiple (logoType) {
      this.$emit('onSendMultiple', logoType)
    },
    handleChange (value, row) {
      this.$emit('onMultiple', value, row)
    },
    updateDataSourcePartNumber () {
      if (this.data.length === 0) {
        return
      }
      const params = this.createPartNumberParams()
      api.get(`Parts/GetAllDynamic`, { params })
        .then(({ data }) => {
          this.dataSourcePartNumber.records = data.value
          this.dataSourcePartNumber.map = data.value.reduce((result, item) => {
            result[item.id] = item
            return result
          }, {})
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
    },
    createPartNumberParams () {
      let params = {}
      const partIDList = this.data.filter(({ partID }) => !!partID).map(({ partID }) => {
        return `id == ${partID}`
      })
      params.filter = partIDList.join(' || ')
      params.select = 'id,partNumber'
      return createParams(params)
    },
    async getPdfContent () {
      if (!this.rfqID) return

      const partIDs = this.data.filter(({ partID }) => !!partID).map(({ partID }) => {
        return partID
      })

      const { content } = await ServicePdf.generateQuoteMultiPartsContent({ id: this.rfqID, partIDs, translate: this.L10n })
      return { content }
    }
  }
}
</script>
